import colors from 'tailwindcss/colors';
import {v2colors} from "./colors";

export const getLighterColor = (color: string, transparency = 1) => {
  const hex = color.replace('#', '');
  const r = Number.parseInt(hex.substring(0, 2), 16);
  const g = Number.parseInt(hex.substring(2, 4), 16);
  const b = Number.parseInt(hex.substring(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${transparency.toString()})`;
};

export const getDarkerColor = (color: string, factor = 0.1) => {
  const hex = color.replace('#', '');
  const r = Number.parseInt(hex.substring(0, 2), 16);
  const g = Number.parseInt(hex.substring(2, 4), 16);
  const b = Number.parseInt(hex.substring(4, 6), 16);

  const new_r = Math.floor(r * (1 - factor));
  const new_g = Math.floor(g * (1 - factor));
  const new_b = Math.floor(b * (1 - factor));

  return `rgba(${new_r}, ${new_g}, ${new_b}, 1)`;
};

const PRIMARY_COLOR = v2colors.brand.midnight;
const PRIMARY_HOVER = v2colors.brand.moss;
const PRIMARY_CONTRAST_COLOR = v2colors.neutral[100];

const SECONDARY_COLOR = v2colors.neutral[100];
const SECONDARY_CONTRAST_COLOR = v2colors.neutral[1000];
const SECONDARY_HOVER = v2colors.neutral[50];

const TERTIARY_COLOR = v2colors.neutral[1000];
const TERTIARY_CONTRAST_COLOR = v2colors.neutral[100];

const BRAND_ACCENT = v2colors.brand.electric;
const HIGHLIGHT = '186 230 253'; //rgb format

// -----------------------------------
// Static Color: Applicable for all themes
// -----------------------------------
const PAST_EVENT = v2colors.neutral[400];
const PAST_EVENT_CONTRAST = colors.slate[600];

const SUCCESS_COLOR = '#BBF7D0';
const SUCCESS_CONTRAST_COLOR = '#14532D';

const ERROR_COLOR = '#FEE2E2';
const ERROR_CONTRAST_COLOR = '#7F1D1D';

const DISABLED = v2colors.neutral[400];

const HINT_BG_COLOR = '#142E47';
const HINT_TEXT_COLOR = '#FFFFFF';
// -----------------------------------

export const base = {
  neutral: v2colors.neutral,
  brand: BRAND_ACCENT,
  highlight: HIGHLIGHT, // sky blue
  disabled: DISABLED, // Disabled color
  primary: {
    bg: PRIMARY_COLOR,
    DEFAULT: PRIMARY_COLOR,
    text: PRIMARY_CONTRAST_COLOR,
    hover: PRIMARY_HOVER,
    lighter: getLighterColor(PRIMARY_COLOR, 0.05),
    darker: getDarkerColor(PRIMARY_COLOR, 0.1),
    foreground: PRIMARY_CONTRAST_COLOR,
    100: v2colors.primary[100],
    200: v2colors.primary[200],
    300: v2colors.primary[300],
    400: v2colors.primary[400],
    500: v2colors.primary[500],
    600: v2colors.primary[600],
    700: v2colors.primary[700],
    800: v2colors.primary[800],
    900: v2colors.primary[900],
    1000: v2colors.primary[1000]
  },
  secondary: {
    DEFAULT: SECONDARY_COLOR,
    bg: SECONDARY_COLOR,
    text: SECONDARY_CONTRAST_COLOR,
    hover: SECONDARY_HOVER,

    foreground: SECONDARY_CONTRAST_COLOR
  },
  tertiary: {
    DEFAULT: TERTIARY_COLOR,
    text: TERTIARY_CONTRAST_COLOR,
    bg: TERTIARY_COLOR,
    hover: getLighterColor(TERTIARY_COLOR, 0.8),
  },
  event: {
    past: {
      DEFAULT: PAST_EVENT,
      text: PAST_EVENT_CONTRAST,
      bg: PAST_EVENT
    }
  },
  success: {
    DEFAULT: SUCCESS_COLOR,
    text: SUCCESS_CONTRAST_COLOR,
    bg: SUCCESS_COLOR
  },
  error: {
    DEFAULT: ERROR_COLOR,
    text: ERROR_CONTRAST_COLOR,
    bg: ERROR_COLOR
  },
  hyperlink: '#4299e1',
  input: '#E5E5E5',
  background: '#FFFFFF',
  overlay: '#6B7280CC',
  map: {
    availableColor: 'rgba(156, 215, 168, 1)',
    notAvailableColor: 'rgba(169, 169, 169, 1)',
    spotNotBookeableUnavailableStroke: 'rgba(153, 95, 95, 0.46)',
    spotNotBookeableUnavailableFill: 'rgba(232, 236, 239, 1)',
    spotNotBookeableStroke: 'rgba(255, 255, 255, 1)',
    spotNotBookeableFill: '#223c5b',
    spotRequiresApprovalStroke: 'rgba(255, 255, 255, 1)',
    spotRequiresApprovalFill: 'rgba(252, 211, 77, 1)',
    spotBookeableWithSchedulesStroke: 'rgba(255, 255, 255, 1)',
    spotFullyAvailableStroke: 'rgba(255, 255, 255, 1)',
    spotNotAssignedFill: 'rgba(232, 236, 239, 1)'
  },
  hint: {
    bg: HINT_BG_COLOR,
    text: HINT_TEXT_COLOR
  }
};
